module.exports = __webpack_public_path__ + "img/woman-body-front.72d39730.png";